// src/components/admin/settings/TabEvent.jsx
import React, { useEffect, useState } from 'react';
import { FaCalendarAlt, FaMapMarkerAlt, FaFilePdf, FaImage, FaList, FaPlus, FaTrash } from 'react-icons/fa';

const BACKEND_URL = process.env.REACT_APP_BACKEND || process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

const TabEvent = ({ config, handleChange, toggleConfig, setProposalFile, setInvitationFile, setWebLogoFile, setConfig }) => {
    const [noteInput, setNoteInput] = useState("");
    const [webLogoPreview, setWebLogoPreview] = useState(null);

    const currentWebLogoUrl = config.web_logo ? `${BACKEND_URL}/uploads/settings/${config.web_logo}` : null;
    const previewLogoUrl = webLogoPreview || currentWebLogoUrl;

    useEffect(() => {
        return () => {
            if (webLogoPreview) URL.revokeObjectURL(webLogoPreview);
        };
    }, [webLogoPreview]);

    const addNote = () => {
        if (!noteInput.trim()) return;
        setConfig(prev => ({
            ...prev,
            important_notes: [...prev.important_notes, noteInput]
        }));
        setNoteInput("");
    };

    const removeNote = (index) => {
        setConfig(prev => ({
            ...prev,
            important_notes: prev.important_notes.filter((_, i) => i !== index)
        }));
    };

    const handleWebLogoChange = (e) => {
        const file = e.target.files?.[0] || null;
        setWebLogoFile(file);
        setWebLogoPreview(file ? URL.createObjectURL(file) : null);
    };

    return (
        <div className="card border-0 shadow-sm animate-fade-in" style={{ background: 'rgba(255, 255, 255, 0.9)', backdropFilter: 'blur(10px)', borderRadius: '20px' }}>
            <div className="card-body p-4">
                <h5 className="fw-bold text-primary mb-4">Informasi Event</h5>
                
                {/* INFO DASAR */}
                <div className="row g-3 mb-5">
                    <div className="col-md-12">
                        <label className="form-label small fw-bold text-muted">Nama Event</label>
                        <input type="text" className="form-control" name="event_name" value={config.event_name} onChange={handleChange} />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label small fw-bold text-muted">Deskripsi Lengkap</label>
                        <textarea className="form-control" rows="3" name="event_description" value={config.event_description} onChange={handleChange}></textarea>
                    </div>
                    <div className="col-md-12">
                        <label className="form-label small fw-bold text-muted"><FaImage className="me-1"/> Logo Web</label>
                        <div className="settings-logo-uploader">
                            <div className="settings-logo-preview">
                                {previewLogoUrl ? (
                                    <img src={previewLogoUrl} alt="Logo Web" />
                                ) : (
                                    <FaImage className="text-muted" />
                                )}
                            </div>
                            <div className="flex-grow-1">
                                <input type="file" className="form-control" accept="image/jpeg,image/jpg,image/png" onChange={handleWebLogoChange} />
                                <div className="form-text small text-muted">Format JPG atau PNG. Biarkan kosong jika tidak ingin mengubah logo.</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label className="form-label small fw-bold text-muted"><FaCalendarAlt className="me-1"/> Tanggal</label>
                        <input type="date" className="form-control" name="event_date" value={config.event_date} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label small fw-bold text-muted"><FaMapMarkerAlt className="me-1"/> Lokasi</label>
                        <input type="text" className="form-control" name="location" value={config.location} onChange={handleChange} />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label small fw-bold text-muted">Kontak Person (HP)</label>
                        <input type="text" className="form-control" name="contact_person" value={config.contact_person} onChange={handleChange} />
                    </div>
                    <div className="col-md-12">
                        <div className="form-check form-switch bg-light p-3 rounded border">
                            <input className="form-check-input ms-0 me-3" type="checkbox" checked={config.is_registration_open} onChange={() => toggleConfig('is_registration_open')} />
                            <label className="form-check-label fw-bold">Buka Pendaftaran Peserta</label>
                        </div>
                    </div>
                </div>

                <hr className="text-muted opacity-25 my-4"/>
                <h5 className="fw-bold text-primary mb-4">Dokumen & Unduhan</h5>

                {/* PROPOSAL */}
                <div className="card bg-light border-0 p-3 mb-3">
                    <h6 className="fw-bold mb-3"><FaFilePdf className="me-2 text-danger"/>Proposal / Technical Handbook</h6>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <input type="text" className="form-control form-control-sm mb-2" placeholder="Judul Dokumen" name="proposal_title" value={config.proposal_title} onChange={handleChange} />
                            <textarea className="form-control form-control-sm" rows="2" placeholder="Deskripsi singkat..." name="proposal_description" value={config.proposal_description} onChange={handleChange}></textarea>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small text-muted">Upload File PDF Baru</label>
                            <input type="file" className="form-control" accept="application/pdf" onChange={(e) => setProposalFile(e.target.files[0])} />
                            <div className="form-text small text-muted">Biarkan kosong jika tidak ingin mengubah file.</div>
                        </div>
                    </div>
                </div>

                {/* SURAT UNDANGAN */}
                <div className="card bg-light border-0 p-3 mb-4">
                    <h6 className="fw-bold mb-3"><FaFilePdf className="me-2 text-primary"/>Surat Undangan Resmi</h6>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <input type="text" className="form-control form-control-sm mb-2" placeholder="Judul Dokumen" name="invitation_title" value={config.invitation_title} onChange={handleChange} />
                            <textarea className="form-control form-control-sm" rows="2" placeholder="Deskripsi singkat..." name="invitation_description" value={config.invitation_description} onChange={handleChange}></textarea>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label small text-muted">Upload File PDF Baru</label>
                            <input type="file" className="form-control" accept="application/pdf" onChange={(e) => setInvitationFile(e.target.files[0])} />
                        </div>
                    </div>
                </div>

                {/* CATATAN PENTING */}
                <h6 className="fw-bold mb-2"><FaList className="me-2"/>Catatan Penting (Info Manager)</h6>
                <div className="input-group mb-3">
                    <input type="text" className="form-control" placeholder="Tulis info penting disini..." value={noteInput} onChange={(e) => setNoteInput(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addNote())} />
                    <button className="btn btn-primary" type="button" onClick={addNote}><FaPlus/> Tambah</button>
                </div>
                <ul className="list-group">
                    {config.important_notes.map((note, idx) => (
                        <li key={idx} className="list-group-item d-flex justify-content-between align-items-center">
                            {note}
                            <button type="button" className="btn btn-sm btn-outline-danger border-0" onClick={() => removeNote(idx)}><FaTrash/></button>
                        </li>
                    ))}
                    {config.important_notes.length === 0 && <li className="list-group-item text-muted fst-italic">Belum ada catatan.</li>}
                </ul>
            </div>
        </div>
    );
};

export default TabEvent;
